// extracted by mini-css-extract-plugin
export default {"modal":"Confirm_modal__wvpYJ","buttons":"Confirm_buttons__sSB7D","cancel":"Confirm_cancel__Zfgj9","delete":"Confirm_delete__5XRjm"};